import { colors } from '../../constants';
import { ISetBackgroundColor } from '../actions/backgroundColor';

const initialState = colors.greenBg;

export const backgroundColor = (
    state = initialState,
    action: ISetBackgroundColor
) => {
    switch (action.type) {
        case 'SET_BACKGROUND_COLOR':
            return action.payload;
        default:
            return state;
    }
};
